module.exports = __webpack_public_path__ + "assets/images/vm2vcfvA.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wopi-wide.png
// module id = 120
// module chunks = 0